import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const ego = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            layout: {
                backText: 'Zurück zu e-go.com'
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/e-go'
        },
    }
}
